import BaseDecorator from "./BaseDecorator";
export default class AdminUserDecorator extends BaseDecorator {}



// WEBPACK FOOTER //
// ./src/lib/decorators/AdminUserDecorator.js